import { useEffect, useState } from 'react';
import { playHaptic } from '../haptics';
import { ScreenHeader } from '../components/ScreenHeader';
import { getBalance, formatBalance } from '../balance';
import { getMyPlace } from '../leaderboard';

const img = (name) => `${process.env.PUBLIC_URL}/img/${name}`;

const GAMES = [
  { title: ['Угадай', 'пару'], hash: '/pair-game', icon: 'icon-dices.svg' },
  { title: ['Три', 'в ряд'], hash: '/match-3', icon: 'icon-categories.svg' },
  { title: ['Собери', 'портфель'], hash: '/sort-game', icon: 'icon-suitcase.svg' },
];

function Home({ onOpen }) {
  const [balance, setBalance] = useState(getBalance);
  const place = getMyPlace('week', balance);

  useEffect(() => {
    const update = () => setBalance(getBalance());
    window.addEventListener('balance-change', update);
    return () => window.removeEventListener('balance-change', update);
  }, []);

  return (
    <div className="app home">
      <ScreenHeader />

      <section className="balance" aria-label="Баланс">
        <p className="balance-label">Баланс</p>
        <div className="balance-value">
          <span>{formatBalance(balance)}</span>
          <img src={img('icon-flash.svg')} alt="" draggable="false" />
        </div>
        <div className="balance-user">
          <span>Вы</span>
          <img src={img('icon-users.svg')} alt="" draggable="false" />
          <span>#{place}</span>
        </div>
      </section>

      <section className="games" aria-label="Игры">
        {GAMES.map((game) => (
          <button
            key={game.hash}
            type="button"
            className="game-tile"
            data-cuelume-press="pulse"
            data-cuelume-release="scan"
            onClick={() => {
              playHaptic('selection');
              onOpen(game.hash);
            }}
          >
            <img className="game-icon" src={img(game.icon)} alt="" draggable="false" />
            <span className="game-title">
              {game.title[0]}
              <br />
              {game.title[1]}
            </span>
            <span className="play-pill">
              <img src={img('icon-play.svg')} alt="" draggable="false" />
              Играть
            </span>
          </button>
        ))}
      </section>
    </div>
  );
}

export default Home;
